<template>
    <div id="ContainerDrug"> 
        <h4 v-if="this.$attrs.editMode" class="page-title text-truncate">
            {{$t('drug.Edit')}}
        </h4>
        <h4 v-if="!this.$attrs.editMode" class="page-title text-truncate">
            {{$t('drug.Add')}}        
        </h4> 

        <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdEdit
                    v-model="itemEditable.drugCode"                    
                    v-bind:Label="$t('drug.DrugCode')"          
                    v-bind:isReadOnly="this.$attrs.editMode"
                    v-bind:isRequired="true"
                    v-bind:MaxLengthProp="50"
                    v-bind:isValid="isCodeValid"
                    v-on:blur="onCodeBlur(itemEditable.drugCode)"
                    :InvalidFeedback="$t('drug.DrugRequired')"
                    :SearchFieldCode="'code'"
                    v-bind:Id="'input_drug'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="$t('drug.BrandName')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'drugname'"  
                    v-bind:MaxLengthProp="50"  
                    v-model="itemEditable.drugname"
                    v-bind:isRequired="true"
                    v-bind:isValid="isBrandNameValid"
                    v-bind:Id="'input_drug_name'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="$t('drug.GenericName')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'activeingredients'"  
                    v-bind:MaxLengthProp="50"  
                    v-model="itemEditable.activeingred"
                    v-bind:isRequired="true"
                    v-bind:isValid="isActiveIngredientValid"
                    v-bind:Id="'input_actIngre'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                    v-bind:Label="$t('drug.Strength')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'dosage'"  
                    v-bind:MaxLengthProp="10"  
                    v-model="itemEditable.dosage"
                    v-bind:isRequired="true"
                    v-bind:isValid="isStrengthValid"
                    v-bind:Id="'input_dosage'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="$t('drug.DosageForm')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'form'"  
                    v-bind:MaxLengthProp="10"  
                    v-model="itemEditable.form"
                    v-bind:isRequired="true"
                    v-bind:isValid="isFormValid"
                    v-bind:Id="'input_m_form'"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdSelect
                    v-bind:Label="$t('Medication.RouteN')"
                    v-bind:Options="RouteNameList"
                    v-bind:Model="itemEditable.routeName"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    :IsDisabled=this.isReadOnlyDrug             
                    :Input="changeDropDownRouteName"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">         
                <MdSelect
                    v-bind:Label="$tc('Shared.ActionsTxt')"
                    v-bind:Options="ActionList"
                    v-bind:Model="itemEditable.action"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    v-bind:isRequired="true"
                    v-bind:isValid="isActionValid"
                    :IsDisabled=this.isReadOnlyDrug               
                    :Input="changeDropDownAction"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdSelect
                    v-bind:Label="$t('Medication.When')"
                    v-bind:Options="WhenList"
                    v-bind:Model="itemEditable.whenSig"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"    
                    :IsDisabled=this.isReadOnlyDrug          
                    :Input="changeDropDownWhen"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdSelect
                    v-bind:Label="$t('Medication.Reason')"
                    v-bind:Options="ReasonList"
                    v-bind:Model="itemEditable.reason"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"    
                    :IsDisabled=this.isReadOnlyDrug          
                    :Input="changeDropDownReason"/>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdEdit 
                    v-bind:Label="$t('drug.Rxnorm')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'rxnorm'"  
                    v-bind:MaxLengthProp="10"  
                    v-model="itemEditable.rxNorm"
                    v-bind:isRequired="false"
                    v-bind:Id="'input_rxnorm'"/>
            </b-col>
            <b-col lg="2" md="2" sm="12">
                <MdEdit 
                    v-bind:Label="$t('drug.Snomed')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'snomed'"  
                    v-bind:MaxLengthProp="10"  
                    v-model="itemEditable.snoMedCode"
                    v-bind:isRequired="false"
                    v-bind:Id="'input_snomd'"/>
            </b-col>
            <b-col lg="2" md="2" sm="12">
                <MdEdit 
                    v-bind:Label="$t('drug.DOHCode')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'othercode'"  
                    v-bind:MaxLengthProp="10"  
                    v-model="itemEditable.otherCode"
                    v-bind:isRequired="true"
                    v-bind:isValid="isDOHCodeValid"
                    v-bind:Id="'input_ocode'"/>
            </b-col>
            <b-col lg="2" md="2" sm="12">
                <MdEdit 
                    v-bind:Label="$t('drug.NDCCode')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'ndc'"  
                    v-bind:MaxLengthProp="10"  
                    v-model="itemEditable.ndc"
                    v-bind:isRequired="false"
                    v-bind:Id="'input_ndc'"/>
            </b-col>
            <b-col lg="2" md="2" sm="12">
                <MdEdit 
                    v-bind:Label="$t('drug.GFCCode')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'gfc'"  
                    v-bind:MaxLengthProp="10"  
                    v-model="itemEditable.gfc"
                    v-bind:isRequired="false"
                    v-bind:Id="'input_gfc'"/>
            </b-col>
        </b-row>
        
        <b-row>
            <b-col lg="4" md="4" sm="12">             
                <MdRadioGroup
                    v-bind:Label="$t('Shared.Status')"
                    v-model="itemEditable.status"
                    v-bind:Options="StatusSelectList"
                    v-bind:Name="'Status'"                                   
                />
            </b-col>
            <b-col lg="4" md="4" sm="12">             
                <MdRadioGroup
                    v-bind:Label="$t('drug.Usage')"
                    v-model="itemEditable.drugUsage"
                    v-bind:Options="UsageSelectList"
                    v-bind:Name="'Usage'"                                   
                />
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdSelect
                    v-bind:Label="$t('drug.DrugType')"
                    v-bind:Options="ProductTypeSelectList"
                    v-bind:Model="itemEditable.iscontrolledsubstance"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    :IsDisabled=this.isReadOnlyDrug               
                    :Input="changeDropDownProductType"/>
            </b-col>
        </b-row>       
        <b-row>
            <b-col lg="4" md="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('drug.IsLook')"
                    v-bind:Name="'checkbox-LookAlikeSoundAlike'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="'Y'"
                    v-bind:UncheckedValue="'N'"
                    v-model="itemEditable.isLasa"     
                    v-bind:isReadOnly=this.isReadOnlyDrug            
                />                    
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('drug.IsHigh')"
                    v-bind:Name="'checkbox-HighAlert'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="'Y'"
                    v-bind:UncheckedValue="'N'"
                    v-model="itemEditable.isHighAlert"
                    v-bind:isReadOnly=this.isReadOnlyDrug                 
                />                    
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('drug.AllowMultActivePresc')"
                    v-bind:Name="'checkbox-AllowMultActivePresc'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="'Y'"
                    v-bind:UncheckedValue="'N'"
                    v-model="itemEditable.allowMultActivePresc"  
                    v-bind:isReadOnly=this.isReadOnlyDrug               
                />                    
            </b-col>
        </b-row>

        <MdTitle v-bind:Text="$t('drug.RequiredAsse')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
        <b-row>
            <b-col md="12" lg="12" sm="12">       
                <MdCheckListBox2 
                    v-model="ModelNoteIds"
                    v-bind:OnChangeProp="onChangeAssessment"
                    v-bind:Options="assessmentList"
                    v-bind:Height="'100px'"
                    v-bind:columnCount="4"
                    :textField="'testDescription'"
                    :valueField="'testCode'"> 
                </MdCheckListBox2>
            </b-col>
        </b-row>

        <MdTitle v-bind:Text="$t('drug.Comments')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
        <b-row>
            <b-col md="12" lg="12" sm="12">
                <MdMemo 
                    v-bind:Name="'comments'"
                    v-model="itemEditable.comments"
                    v-bind:Rows="'6'"
                    v-bind:MaxRows="'250'" 
                    v-bind:Id="'input_d_comments'"/>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">      
            <MdButton
                v-bind:Label="$t('drug.DrugList')"
                v-bind:Name="'btndruglist'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="DiscardChanges"/>    
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="(this.isReadOnlyDrug)?'primary mx-2':'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
                v-bind:isReadOnly="isReadOnlyDrug || !pendingChanges"
                v-bind:Name="'btn_save_drug'"/>
        </div>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js'
import Permission from '@/common/Permission'
import DrugService from '@/services/drug.service.js'
import EnumService from '@/services/enum.service'
import GlobalService from '@/services/global.service'
import Utils from "@/common/utils"
import { EventBus } from '../../../../event-bus.js'

export default {
    name: 'DrugUAE',
    mixins: [ShowMessage, DBFunctions, Permission],

    data() {
        return {
            OptionsRightMenu:{
                visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                PatientCode:'',
                Mode:this.edit_mode,
                favButtonAtion:false          
            },
            itemEditable: {
                drugCode:'',
                drugname:'',
                dosage:'',
                form:'',
                activeingred:'',
                routeName:'',
                action:'',
                whenSig:'',
                rxNorm:'',
                snoMedCode:'',
                otherCode:'',
                restrictchange:'N',
                status:'',
                iscontrolledsubstance:'',
                substancescheduleselect:'',
                lookalikesoundalike:'N',
                isHighAlert:'N',
                methaspense:'N',
                assessment:'',
                comments:'',
                reason:'',
                ndc:'',
                gfc:'',
                drugUsage: '',
                notesIds: '',
                isLasa: '',
                allowMultActivePresc:'N'
            },
            ModelNoteIds: [],
            RouteNameList: [],
            ActionList: [],
            WhenList: [],
            StatusSelectList: EnumService.StatusOptions,
            ProductTypeSelectList: EnumService.UAEProductTypeSelectList,
            UsageSelectList:EnumService.DrugUsage,
            ReasonList: [],
            assessmentList: [],
            isCodeValid: true,
            isDOHCodeValid:true,
            isActionValid:true,
            isFormValid:true,
            isStrengthValid:true,
            isActiveIngredientValid:true,
            isBrandNameValid:true,
            isReadOnlyDrug:false,
            pendingChanges: false,
            loading: true
        }
    },

    methods: {
        async getDrug(){
            if(this.$attrs.editMode) {
                await DrugService.Get(this.$route.params.id)
                    .then((response) => {
                        if(response.status == '200' && response.data){
                            this.itemEditable = response.data;  

                            if (this.itemEditable.notesIds) {
                                const notesIds = this.itemEditable.notesIds.split(',');
                                this.ModelNoteIds = this.assessmentList.filter((value) => notesIds.some(id => id === value.testCode)).map(value => { return value.testCode });
                                setTimeout(() => this.loading = false, 2000);                              
                            } else {
                                this.loading = false;
                            }
                        }
                        
                        console.log(this.itemEditable)
                    })
                    .catch((error) => {     
                        this.loading = false;                
                        this.showResponseErrorMessage(error);     
                    });     
            } else {
                this.loading = false;
            }
        },

        DiscardChanges() {
            this.checkExistFavorite('/app/druglist');
            this.$router.push({name: "DrugList"});
        },

        DoAction(){       
            !this.$attrs.editMode ? this.AddDrug() : this.EditDrug(); 
        },

        SaveOrEdit(){ 
            if (this.validate_required()) {
                this.DoAction();
            } else {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");          
            }
        },    

        EditDrug(){
            DrugService.Update(this.$route.params.id, this.itemEditable)
                .then((response) => {
                    if(response.status == '200'){
                        this.pendingChanges = false;   
                        this.$router.push({name: "DrugList"}).catch(()=>{});                      
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                        , 50); 
                    }                             
                })
                .catch((error) => {   
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }); 
        },

        AddDrug(){
            if(!this.CodeExist){
                DrugService.Add(this.itemEditable)
                    .then((response) => {
                        if(response.status == '200'){
                            this.pendingChanges = false;   
                            this.$router.push({name: "DrugList"}).catch(()=>{});
                        
                            setTimeout(() => 
                                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: "success"
                                })
                            , 50); 
                        }                          
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    }); 
            }else{
                this.showMessage(this.$tc('Msg.Error'),this.$t('drug.DrugCodeExist'),"error");
            }
        },

        validate_required() {       
            this.isCodeValid = !Utils.isNullOrEmptyString(this.itemEditable.drugCode);
            this.isDOHCodeValid = !Utils.isNullOrEmptyString(this.itemEditable.otherCode);
            this.isActionValid = !Utils.isNullOrEmptyString(this.itemEditable.action);
            this.isFormValid = !Utils.isNullOrEmptyString(this.itemEditable.form);
            this.isStrengthValid = !Utils.isNullOrEmptyString(this.itemEditable.dosage);
            this.isActiveIngredientValid = !Utils.isNullOrEmptyString(this.itemEditable.activeingred);
            this.isBrandNameValid = !Utils.isNullOrEmptyString(this.itemEditable.drugname);
            return this.isCodeValid && this.isDOHCodeValid && this.isActionValid &&
                this.isFormValid && this.isStrengthValid && this.isActiveIngredientValid &&
                this.isBrandNameValid;
        },

        onCodeBlur(value) {
            if (!this.$attrs.editMode) {           
                if (value.trim()!== '') {          
                    var parameter = {
                        "code":value
                    };

                    DrugService.getDrugsByCode(parameter)
                        .then((response) => {
                            if(response.status == '200' && response.data){
                                console.log(response.data)
                                if(response.data.length > 0){
                                    this.showMessage(this.$tc('Msg.Error'),this.$t('drug.DrugCodeExist'),"error");
                                    this.CodeExist = true;
                                } else {
                                    this.CodeExist = false;
                                } 
                            }                    
                        })
                        .catch((error) => {
                            this.showResponseErrorMessage(error);           
                        });  
                }
            }
        },

        changeDropDownRouteName(value) {
            this.itemEditable.routeName = value ? value.value : ''; 
        },

        changeDropDownAction(value) {
            this.itemEditable.action = value ? value.value : ''; 
        },

        changeDropDownWhen(value) {
            this.itemEditable.whenSig = value ? value.value : ''; 
        },

        changeDropDownReason(value){   
            this.itemEditable.reason = value ? value.value : '';              
        },

        changeDropDownProductType(value) {
            this.itemEditable.iscontrolledsubstance = value ? value.value : '';
        },

        onChangeAssessment(value) {
            this.ModelNoteIds = value;
            this.itemEditable.notesIds = value ? value.join(",") : ''
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault()
                e.returnValue = ''	
            }
        },

        async getAssessmentList() {
            await GlobalService.getAssessment()
                .then((response) => {
                    if(response.status == '200'){    
                        this.assessmentList = response.data;
                    }                             
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getRouteName(){          
            var param = {
                CodeType:"ROUTE",
                GroupCreation:"SIG"
            };     
            await GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.RouteNameList = response.data.map(element => {return {value: element.value, text: element.description}});
                    }                   
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);                   
                });        
        },

        async getAction(){         
            var param = {
                CodeType:"ACTION",
                GroupCreation:"SIG"
            };     
            await GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.ActionList = response.data.map(element => {return {value: element.value, text: element.description}});    
                    }                   
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);                  
                });        
        },

        async getReason(){           
            var param = {
                CodeType:"REASON",
                GroupCreation:"SIG"
            };     
            await GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.ReasonList = response.data.map(element => {return {value: element.value, text: element.description}});
                    }                   
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);                  
                });        
        },

        async getWhen(){            
            var param = {
                CodeType:"WHEN",
                GroupCreation:"SIG"
            };     
            await GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.WhenList = response.data.map(element => {return {value: element.value, text: element.description}});       
                    }                   
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);                  
                });        
        },

        async runAll() {
            await Promise.allSettled([
                this.getAssessmentList(), 
                this.getReason(), 
                this.getRouteName(), 
                this.getAction(), 
                this.getWhen()
            ]);

            await this.getDrug();
        }

    },

    created(){
        this.InitializePermissions(!this.$attrs.editMode ? 'AddView' : 'EditView');

        if (!this.IsAccessAllowed()) {
            return;
        }
        
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    async mounted(){
        if (!this.IsAccessAllowed()) {
            return;
        }

        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        
        switch(layoutStatus) {
            case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        await this.runAll();
        EventBus.$on("onChanged", (e) => { 
            if (!this.loading && !this.isReadOnlyDrug) {
                this.pendingChanges = e.Changed; 
            }
        })
    },

    destroyed(){
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false; 
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy () {
        if (!this.IsAccessAllowed()) {
            return;
        }
        
        EventBus.$off("onChanged");
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    },
}
</script>